export const BRAND = {
  name: "DV Solutions Inc.",
  phone: "484-513-6989",
  phoneHref: "tel:+14845136989",
  email: "dv.solutions.inc5@gmail.com",
  emailHref: "mailto:dv.solutions.inc5@gmail.com",
  logo: "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/mlg6mt9a_162666.png",
};

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/uam19wpu_162864.jpg";

export const PROJECT_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/uam19wpu_162864.jpg",
    label: "Rooftop HVAC pipe insulation",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/fcr5fhro_162856.jpg",
    label: "Commercial mechanical insulation",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_eastern-insulation/artifacts/73pmnu27_170805.jpg",
    label: "Warehouse panel insulation",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_eastern-insulation/artifacts/z1kph79s_170802.jpg",
    label: "Industrial ceiling protection",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/j0eq53oo_162868.jpg",
    label: "Pipe detail & finish",
  },
];

export const SERVICE_IMAGES = {
  painting:
    "https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1200&q=80",
  insulation:
    "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/fcr5fhro_162856.jpg",
  commercial_insulation:
    "https://customer-assets.emergentagent.com/job_d16730b3-d9dc-49be-bba7-26684327559f/artifacts/uam19wpu_162864.jpg",
  drywall:
    "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1200&q=80",
  remodeling:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=80",
  pressure_wash:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=80",
  cleaning:
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80",
};
